import React, { useState, useEffect } from 'react'

const defaultPlaceholder = 'This element requires JavaScript to be enabled.'

/**
 * Reusable fallback component that displays custom message if JavaScript is
 * disabled.
 */
export default ({ placeholder = defaultPlaceholder, className, children }) => {
    const [initialized, setInitialized] = useState(false)
    useEffect(() => {
        if (!initialized) setInitialized(true)
    }, [initialized])
    return initialized ? children : <div className={className}>{placeholder}</div>
}
